import { AssistantPhoto, AssistantPhotoOutlined, EventAvailable, EventBusy } from "@mui/icons-material"
import { Stack, Typography } from "@mui/material"
import { DatePicker, TimePicker } from "@mui/x-date-pickers"
import CheckRole from "components/CheckRole"
import CustomCard from "components/CustomCard"
import CustomIconButton from "components/CustomIconButton"
import SelectInput from "components/files/SelectInput"
import SwitchInput from "components/files/SwitchInput"
import NullCheck from "components/NullCheck"
import { DEPARTMENT_MANAGER, MANAGER } from "config/roles"
import { ST_TYPE_ID } from "containers/servicesCall/const"
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation"
import moment from "moment"
import { COLORS } from "config/const"
import SelectColorPicker from "components/files/SelectColorPicker"

const EmpAndDate = ({
  control,
  data,
  errors,
  empList,
  workDt,
  setWorkDt,
  stTypeId,
  editHasFlag
}) => {
  const { bt } = useBizTypeTranslation();

  const applyDatePart = (prev, d) => {
    const base = (prev ?? moment()).clone();
    return base
      .year(d.year())
      .month(d.month())
      .date(d.date());
  };

  const applyTimePart = (prev, t) => {
    const base = (prev ?? moment()).clone();
    return base
      .hour(t.hour())
      .minute(t.minute())
      .second(t.second() ?? 0)
      .millisecond(0);
  };

  return (
    <CustomCard>

      <Stack direction='row' spacing={2}>
        <CustomCard>
          <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="center">

            <Stack direction="row" spacing={2} alignItems="center">
              <Stack direction='row' spacing={2} alignItems='center'>
                <CheckRole role={DEPARTMENT_MANAGER}>
                  <Stack direction="row" spacing={2}>
                    <SelectInput
                      addFlex
                      width={{ xs: "100%", md: 200 }}
                      control={control}
                      errors={errors}
                      name="employee"
                      title="SELECT_EMPLOYEE"
                      options={empList}
                      defaultValue={data?.employee ?? empList[0]?.id}
                    />
                  </Stack>
                </CheckRole>

                <NullCheck valueForCheck={stTypeId === ST_TYPE_ID.CLOSE}>
                  <CheckRole role={MANAGER}>
                    <SwitchInput
                      width="100%"
                      errors={errors}
                      name="approval"
                      title="APPROVAL"
                      control={control}
                    />
                  </CheckRole>
                </NullCheck>
              </Stack>

              <Stack direction='row' spacing={1} alignItems='center'>
                <CheckRole role={MANAGER}>
                  <SelectColorPicker
                    name="color"
                    title="COLOR"
                    colors={COLORS}
                    errors={errors}
                    control={control}
                  />
                </CheckRole>

                <CustomIconButton
                  icon={data?.hasFlag ? <AssistantPhoto /> : <AssistantPhotoOutlined />}
                  onClick={() => editHasFlag({ call: data, hasFlag: data?.hasFlag ? false : true })}
                  size={40}
                  bgcolor="success.main"
                />
              </Stack>
            </Stack>

            <Stack>
              <Stack direction='row' spacing={1} alignItems='center'>
                <DatePicker
                  label={bt("WORK_DT")}
                  sx={{ width: 130 }}
                  value={workDt}
                  format="DD/MM/YY"
                  onChange={(d) => d && setWorkDt((prev) => applyDatePart(prev, d))}
                />
                <TimePicker
                  label={bt("TIME")}
                  value={workDt}
                  sx={{ width: 120 }}
                  minutesStep={1}
                  onChange={(t) => t && setWorkDt((prev) => applyTimePart(prev, t))}
                />
              </Stack>

            </Stack>


          </Stack>


        </CustomCard>
      </Stack>
    </CustomCard >
  )
}
export default EmpAndDate